import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageTracker from "@/components/PageTracker";
import ExitIntentOffer from "@/components/ExitIntentOffer";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Forms from "@/pages/Forms";
import ServiceManager from "@/pages/ServiceManager";
import CollisionManager from "@/pages/CollisionManager";
import HRManager from "@/pages/HRManager";
import PartsManager from "@/pages/PartsManager";
import SalesManager from "@/pages/SalesManager";
import FallPreview from "@/pages/FallPreview";
import FormDetail from "@/pages/FormDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CheckoutReturn from "@/pages/CheckoutReturn";

import PortalLayout from "@/pages/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Library from "@/pages/portal/Library";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDocuments from "@/pages/admin/AdminDocuments";
import MasterImport from "@/pages/admin/MasterImport";
import AdminFeedback from "@/pages/admin/AdminFeedback";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminInsights from "@/pages/admin/AdminInsights";
import AdminSystems from "@/pages/admin/AdminSystems";

import OpsLayout from "@/pages/ops/OpsLayout";
import OpsDashboard from "@/pages/ops/OpsDashboard";
import ContentLibrary from "@/pages/ops/ContentLibrary";
import PublishingQueue from "@/pages/ops/PublishingQueue";
import LaunchCenter from "@/pages/ops/LaunchCenter";

function MarketingLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <ExitIntentOffer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <PageTracker />
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/for/service-manager" element={<ServiceManager />} />
              <Route path="/for/collision-manager" element={<CollisionManager />} />
              <Route path="/for/hr-manager" element={<HRManager />} />
              <Route path="/for/parts-manager" element={<PartsManager />} />
              <Route path="/for/sales-manager" element={<SalesManager />} />
              <Route path="/fall-preview" element={<FallPreview />} />
              <Route path="/forms/:code" element={<FormDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout/return" element={<CheckoutReturn />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/portal" element={<ProtectedRoute><PortalLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="library" element={<Library />} />
            </Route>

            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="documents" element={<AdminDocuments />} />
              <Route path="master-import" element={<MasterImport />} />
              <Route path="feedback" element={<AdminFeedback />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="emails" element={<AdminEmails />} />
              <Route path="insights" element={<AdminInsights />} />
              <Route path="systems" element={<AdminSystems />} />
            </Route>

            <Route path="/ops" element={<ProtectedRoute adminOnly><OpsLayout /></ProtectedRoute>}>
              <Route index element={<OpsDashboard />} />
              <Route path="content" element={<ContentLibrary />} />
              <Route path="publishing" element={<PublishingQueue />} />
              <Route path="launch" element={<LaunchCenter />} />
            </Route>
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
